<template>
    <div v-if="alertObj.isShow">
        <div class="popup-dimmed on" />
        <div class="popup-wrapper alert on">
            <div class="popup-container">
                <div class="popup-body">
                    <p>{{ alertObj.msg }}</p>
                </div>

                <div class="popup-bottom">
                    <div class="btn-wrapper">
                        <button class="btn btn-confirm" @click="close()">
                            <span>확인</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <!-- // loading -->
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Alert',
    components: {},
    data: () => {
        return {};
    },
    computed: {
        ...mapState({
          alertObj: state => state.facemapping.alert
        })
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapActions(['alert']),
        close(){
          this.alert({isShow:false});
        }
    }
};
</script>
